export default {
    CLOSED: 'modalClosed',
    CONFIRMED: 'modalConfirmed',
    CANCELLED: 'modalCancelled'
};
